<template>
  <div class="register-success">
    <div
      class="content"
      v-if="['0',0,'1',1].includes(this.account.providerAccountInfo.auditStatus)"
    >
      <div class="img">
        <img src="@/assets/baibu/ic-success.png" alt="">
      </div>
      <div class="text">
        账号注册成功
        <p
          v-if="['0',0].includes(this.account.providerAccountInfo.auditStatus)"
        >等待审核中</p>
      </div>
    </div>
    <div
      class="content"
      v-if="['2',2].includes(this.account.providerAccountInfo.auditStatus)"
    >
      <div class="img">
        <img src="@/assets/baibu/ic-error.png" alt="">
      </div>
      <div class="text">
        账号审核不通过
      </div>
      <div
        class="btn"
        @click="againAudit"
      >
        重新提交审核
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { getAccountDetail } from '@/api/baibu';

export default {
  name: 'RegisterSuccess',
  data() {
    return {
      sourceTypeName: 'provider',
      account: {
        providerAccountInfo: {},
      },
    };
  },
  created() {
    if (Cookies.get(`${this.sourceTypeName}_userId`)) {
      this.getAccount();
    } else {
      this.$router.replace({
        path: '/baibu/provider/login',
      });
    }
  },
  methods: {
    getAccount() {
      getAccountDetail({
        businessType: this.sourceTypeName.toUpperCase(),
      }, {
        'req-agent': `${this.sourceTypeName}-h5`,
        'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
      }).then((res) => {
        this.account = res.data;
      }).catch((error) => {
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/provider/login');
        }
        console.log('error', error);
      });
    },
    againAudit() {
      window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
      this.$router.push({
        path: '/baibu/provider/register',
        query: {
          againAudit: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-success {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.8rem;
    font-size: 0.46rem;
    color: #333;
    img {
      width: 2.1rem;
      height: 2.1rem;
    }
    .text {
      margin-top: 0.8rem;
      line-height: 1.2;
      text-align: center;
      font-weight: bold;
    }
    .btn {
      width: 4rem;
      height: 0.78rem;
      line-height: 0.78rem;
      background: #1677FF;
      border-radius: 0.4rem;
      color: #fff;
      text-align: center;
      font-size: 0.3rem;
      margin-top: 0.4rem;
    }
  }
}
</style>
